import {Api} from '@/api/Api';
import type {OPRFile} from "@/models/OPRFile";

export default class BidPackageFileAPI extends Api {

  index(projectId: number, bidPackageId: number, params: any, publicProject = false): Promise<OPRFile[]> {
    return this.get({
      url: publicProject
        ? `projects/${projectId}/public/gc-files`
        : `projects/${projectId}/bid-packages/${bidPackageId}/gc-files`,
      queryParams: params
    })
    .then((res) => this.processResponse(res));
  }

  zip(projectId: number, bidPackageId: number, filename: string, params: any, publicProject = false): Promise<any> {
    return this.get({
      url: publicProject
        ? `projects/${projectId}/public/gc-files/zip`
        : `projects/${projectId}/bid-packages/${bidPackageId}/gc-files/zip`,
      queryParams: params
    })
    .then(async (response) => {
      if (!response.ok) {
        await this.processResponse(response);
      }

      return response.blob();
    })
    .then((response) => {
      const file = new Blob(
          [response],
          {type: 'application/zip'},
      );
      const link = document.createElement('a');
      const objectUrl = URL.createObjectURL(file);
      link.href = objectUrl;
      link.download = `${filename}.zip`;
      document.body.append(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(objectUrl);
    });
  }

  download(projectId: number, bidPackageId: number, file: OPRFile, publicProject = false): Promise<void> {
    if (!file.url) {
      return Promise.reject('File URL is unavailable');
    }

    const loggingRequest = this.post({
      url: publicProject
        ? `projects/${projectId}/public/gc-files/${file.id}/download-activity`
        : `projects/${projectId}/bid-packages/${bidPackageId}/gc-files/${file.id}/download-activity`,
    })
      .then((response) => this.processResponse(response))
      .then(() => undefined);

    const link = document.createElement('a');
    link.href = file.url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.append(link);
    link.click();
    link.remove();

    return loggingRequest;
  }
};
